import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { getDrawLineByIDAndIndex } from "../../functions";
import CanvasDrawItem from "./CanvasDrawItem";
const CanvasDrawLine = React.memo(({ uuid, index, drawCanvas, selectedId, handlerUpdateLine }) => {
    const drawLineList = useSelector((state) => getDrawLineByIDAndIndex(state, uuid, index), shallowEqual);
    return (React.createElement(React.Fragment, null, drawLineList.map((line, index) => (React.createElement(CanvasDrawItem, { key: index, selectedId: selectedId, drawCanvas: drawCanvas, line: line, scale: 1, handlerUpdateLine: handlerUpdateLine })))));
});
export default CanvasDrawLine;
